// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#done-empty[data-v-1b88aca8]{overflow:hidden;margin:0}#done-empty p[data-v-1b88aca8]{font-size:15px;font-weight:400;color:#7c8b91;margin-bottom:35px}#done-empty .chat-bubble[data-v-1b88aca8]{font-size:40px;opacity:.5;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
